/* LittleG Tool 06 — Google Maps URL handoff, not a route calculation engine.
 * No geolocation, backend call, storage, ETA inference, auth or GFun.
 */
(function(global){
  'use strict';
  const MODES=new Set(['walking','transit','driving']);
  function place(value){
    if(typeof value!=='string')return null;
    const trimmed=value.trim();
    if(!trimmed||trimmed.length>180||/[\u0000-\u001F\u007F]/.test(trimmed))return null;
    return trimmed;
  }
  function buildDirectionsUrl(origin,destination,mode='walking'){
    const from=place(origin),to=place(destination);
    if(!from||!to||from.toLocaleLowerCase()===to.toLocaleLowerCase()||!MODES.has(mode))return null;
    const url='https://www.google.com/maps/dir/?api=1&origin='+
      encodeURIComponent(from)+'&destination='+encodeURIComponent(to)+'&travelmode='+encodeURIComponent(mode);
    return url.length<=2048?url:null;
  }
  if(typeof module!=='undefined'&&module.exports)module.exports={buildDirectionsUrl,place};
  if(!global.document)return;
  global.document.querySelectorAll('[data-littleg-route-tool]').forEach(form=>{
    const from=form.querySelector('[data-route-origin]');
    const to=form.querySelector('[data-route-destination]');
    const mode=form.querySelector('[data-route-mode]');
    const status=form.querySelector('[data-route-status]');
    if(!from||!to||!mode||!status)return;
    const zh=form.dataset.routeLocale!=='en';
    form.addEventListener('submit',event=>{
      // The native HTML GET submits directly to Google's documented Maps URL,
      // encoding three whitelisted fields only. This handler validates input.
      const url=buildDirectionsUrl(from.value,to.value,mode.value);
      if(!url){
        event.preventDefault();
        status.textContent=zh?'請填寫兩個不同而有效的地點。':'Enter two different valid places.';
        return;
      }
      status.textContent=zh?'將在新分頁開啟 Google 地圖。':'Opening Google Maps in a new tab.';
    });
  });
})(typeof window==='undefined'?globalThis:window);
